import { UnidadePaginateResponse } from "core/features/unidades/typings/unidade";
import { PaginateResult } from "core/resources/types/shared";
import Table from "ui/components/Table";
import useListagemUnidadeColumns from "./components/useListagemUnidadeColumns";
import HeaderTable from "./components/HeaderTable";
import { Control } from "react-hook-form";
import { IndexadorForm } from "core/features/indexador/typings";

interface IndexadorTableProps {
  data: PaginateResult<UnidadePaginateResponse> | undefined;
  searchValue: string;
  onSearch: (q?: string) => any;
  isLoading?: boolean;
  control: Control<IndexadorForm, object>;
  enabledEdit: boolean;
  valor: number;
  form: IndexadorForm;
}

function IndexadorTable({
  data,
  searchValue,
  onSearch,
  isLoading,
  control,
  enabledEdit = false,
  valor,
  form,
}: IndexadorTableProps) {
  const columns = useListagemUnidadeColumns({
    valor,
    form,
    control,
    enabledEdit,
  });

  return (
    <Table
      header={() => <HeaderTable value={searchValue} onSearch={onSearch} />}
      loading={isLoading}
      columns={[...columns]}
      data={data!}
      actions={[]}
    />
  );
}

export default IndexadorTable;
